// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._-_-frontend-components-src-lib-Avatar-__override--S0WUL._-_-frontend-components-src-lib-Avatar-__override--S0WUL {\n  display: inline-flex;\n}", "",{"version":3,"sources":["webpack://./../frontend-components/src/lib/Avatar/Avatar.module.scss"],"names":[],"mappings":"AACE;EACE,oBAAA;AAAJ","sourcesContent":[".override {\n  &#{&} {\n    display: inline-flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"override": "_-_-frontend-components-src-lib-Avatar-__override--S0WUL"
};
export default ___CSS_LOADER_EXPORT___;
